import axios from "axios";

export const state = {
    productcategories: [],
};

export const getters = {
    productcategories: state => state.productcategories,
};

export const mutations = {
    setCategories: (state, productcategories) => (state.productcategories=productcategories),
};

export const actions = {
    fetchCategories({ commit }) {
        axios.get('/categories').then(res => {
            commit('setCategories', res.data.categories)
        })
    },
};
